import {
    FETCHED_TEMPLATES,
    FETCHED_TEMPLATE,
    FETCHED_ELEMENTS,
    MOVE_TEMPLATE_SECTION,
    NEW_TEMPLATE_SECTION,
    SAVED_TEMPLATE,
    DELETE_TEMPLATE_SECTION,
    UPDATE_NEW_PLACEHOLDER,
    OPEN_PLACEHOLDER_EDIT_POPUP,
    CLOSE_PLACEHOLDER_EDIT_POPUP,
    DONE_EDIT_PLACEHOLDER_POPUP,
    FETCHED_EDITS_HISTORY,
    DISABLE_SECTION,
    ENABLE_SECTION,
} from './types';

export function fetchedTemplates(templates) {
    return {
        type: FETCHED_TEMPLATES,
        payload: templates,
    };
}

export function fetchedTemplate(template) {
    return {
        type: FETCHED_TEMPLATE,
        payload: template,
    };
}

export function fetchedElements(response) {
    return {
        type: FETCHED_ELEMENTS,
        payload: {
            elements: response,
        },
    };
}

export function moveSection(dragIndex, hoverIndex, dragCard) {
    return {
        type: MOVE_TEMPLATE_SECTION,
        payload: {
            dragIndex: dragIndex,
            hoverIndex: hoverIndex,
            dragCard: dragCard,
        },
    };
}

export function addNewSection(sectionTypeId, sectionType, dropWhere) {
    return {
        type: NEW_TEMPLATE_SECTION,
        payload: {
            sectionTypeId,
            sectionType,
            dropWhere,
        },
    };
}

export function savedTemplate(data) {
    return {
        type: SAVED_TEMPLATE,
        payload: {
            data: data,
        },
    };
}

export function deleteTemplateSection(sectionId) {
    return {
        type: DELETE_TEMPLATE_SECTION,
        payload: {
            sectionId: sectionId,
        },
    };
}

export function updateNewPlaceholder(newPlaceholder) {
    return {
        type: UPDATE_NEW_PLACEHOLDER,
        payload: newPlaceholder,
    };
}

export function openEditPlaceholderPopup(placeholder, sectionUniqueId) {
    return {
        type: OPEN_PLACEHOLDER_EDIT_POPUP,
        payload: {
            placeholder: placeholder,
            sectionUniqueId: sectionUniqueId,
        },
    };
}

export function closeEditPlaceholderPopup() {
    return {
        type: CLOSE_PLACEHOLDER_EDIT_POPUP,
    };
}

export function doneEditPlaceholder(placeholder) {
    return {
        type: DONE_EDIT_PLACEHOLDER_POPUP,
        payload: placeholder,
    };
}

export function fetchedEditsHistory(editsHistory) {
    return {
        type: FETCHED_EDITS_HISTORY,
        payload: editsHistory,
    };
}

export function disableSection(templateId, sectionId) {
    return {
        type: DISABLE_SECTION,
        payload: {
            templateId: templateId,
            sectionId: sectionId,
        },
    };
}

export function enableSection(templateId, sectionId) {
    return {
        type: ENABLE_SECTION,
        payload: {
            templateId: templateId,
            sectionId: sectionId,
        },
    };
}



// WEBPACK FOOTER //
// ./src/containers/templates/actions.js